import { render, staticRenderFns } from "./Form12ProcessHeader.vue?vue&type=template&id=6055920d&scoped=true"
import script from "./Form12ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form12ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form12ProcessHeader.vue?vue&type=style&index=0&id=6055920d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055920d",
  null
  
)

export default component.exports